export default {
    configuration: false,
    searchList: {
        fieldTrim: true,
        searchTxt: [
            {
                name: '支付订单号',
                value: 'tradeNo',
                type: 'input',
                placeholder: '支付订单号(最多查询100单，以逗号隔开)',
                unfold: true,
                span: 4
            },
            {
                name: '分账支付对象',
                value: 'payObject',
                type: 'select',
                optionNum: 'PAY_OBJECT',
                options: [],
                span: 2,
                unfold: true
            },
            {
                name: '支付状态',
                value: 'payStatus',
                type: 'select',
                optionNum: 'PAY_STATUS_SPECIAL',
                options: [],
                span: 2,
                unfold: true
            },
            {
                name: '发车单号',
                value: 'dispatchNo',
                type: 'input',
                placeholder: '发车单号(最多查询100单，以逗号隔开)',
                span: 4,
                unfold: true
            },
            {
                name: '创建时间',
                value: 'payCreateTime',
                startTime: 'payCreateStart',
                endTime: 'payCreateEnd',
                startPlaceholder: '记录创建开始日期',
                endPlaceholder: '记录创建结束日期',
                type: 'time',
                timeNum: 6,
                unfold: true,
                span: 5
            }
        ],
        unfoldState: false,
        advancedBtn: true
    },
    table: {
        height: 400,
        leftWidth: 120,
        leftOperation: true,
        columns: [
            {
                label: '美的付支付批次号',
                width: 180,
                prop: 'batchNo',
                sort: true,
                info: '<div>司机运费发起支付时，被选中的所有发车单为一个批次。用于美的付的批量付款</div>'
            },
            {
                label: '支付订单号',
                width: 150,
                prop: 'tradeNo',
                sort: true,
                info: '<div>司机运费发起支付时，被选中的所有发车单中同一个司机的所有发车单为一条支付订单</div>'
            },
            {
                label: '支付对象',
                width: 150,
                prop: 'payObject',
                type: 'select',
                optionNum: 'PAY_OBJECT',
                options: [],
                sort: true
            },
            {
                label: '支付金额',
                width: 150,
                prop: 'payAmount',
                sort: true
            },
            {
                label: '收款户名',
                width: 150,
                prop: 'payeeName',
                sort: true
            },
            {
                label: '收款卡号',
                width: 150,
                prop: 'payeeNo',
                sort: true
            },
            {
                label: '支付状态',
                width: 150,
                prop: 'payStatus',
                type: 'select',
                optionNum: 'PAY_STATUS_SPECIAL',
                options: [],
                sort: true
            },
            {
                label: '支付失败说明',
                width: 150,
                prop: 'payFailReason',
                sort: true
            },
            {
                label: '包含的分账单',
                prop: 'divideNoCount',
                type: 'button',
                width: 150,
                sort: true
            },
            {
                label: '支付完成时间',
                prop: 'payDate',
                width: 150,
                sort: true
            },
            {
                label: '支付发起人',
                prop: 'payPromoter',
                width: 200,
                sort: true
            },
            {
                label: '创建时间',
                width: 150,
                prop: 'createTime',
                sort: true
            },
            {
                label: '付款商户号',
                width: 220,
                prop: 'payAccount',
                sort: true
            }
        ],
        action: [
            {
                type: 'text',
                label: '更新状态',
                size: 'mini',
                event: 'updateStatus',
                ifHas: 'payment-record-update'
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 10,
        pageSizes: [10, 20, 50, 100]
    },
    searchTotalTitle: [
        // {
        //     name: '发车单号',
        //     value: 'dispatchNo',
        //     type: 'input',
        //     placeholder: '发车单号(最多查询100单，以逗号隔开)'
        // },
        // {
        //     name: '供应商',
        //     advanceLabel: '供应商',
        //     value: 'carrierName',
        //     advanceConfig: [
        //         { prop: 'supplierNameCn', value: '供应商名称' },
        //         { prop: 'supplierCode', value: '供应商编码' }
        //     ],
        //     tableConfig: [
        //         { prop: 'supplierNameCn', value: '供应商名称' },
        //         { prop: 'supplierCode', value: '供应商编码' },
        //         { prop: 'transNameListStr', value: '采购渠道' }
        //     ],
        //     method: 'post',
        //     prefix: '/api-tms',
        //     advanceUrl: '/srm/supplier/search',
        //     type: 'advance',
        //     advanceNotSearch: true,
        //     queryConditionRequired: true,
        //     cbParams: ['supplierNameCn#carrierName', 'supplierCode#carrierCode'],
        //     advanceCascade: 'supplierCode#carrierCode'
        // },
        {
            name: '司机',
            type: 'advance',
            value: 'driver',
            multiple: true,
            border: true,
            dialogWidth: '800px',
            maxSelect: 5,
            multipleTableColumn: {
                prop: 'name', 'value': '司机名称'
            },
            advanceConfig: [
                { 'prop': 'name', 'value': '司机名称' },
                { 'prop': 'encuMobile', 'value': '司机电话' }
            ],
            tableConfig: [
                { 'prop': 'name', 'value': '司机名称' },
                { 'prop': 'encuMobile', 'value': '司机电话' }
            ],
            advanceUrl: 'suDriver/searchByConditions',
            cbParams: [
                'name#driver', 'encuMobile#driverContactWay'
            ]
        },
        {
            name: '支付时间',
            value: 'payDate',
            startTime: 'payDateStart',
            endTime: 'payDateEnd',
            startPlaceholder: '支付开始日期',
            endPlaceholder: '支付结束日期',
            type: 'time'
        },
        {
            name: '美的付支付批次号',
            value: 'batchNo',
            type: 'input',
            placeholder: '美的付支付批次号'
        }
    ]
};
